import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[accordeonHost]',
})
export class AccordeonHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
